import React from "react";

interface ResizeHandlesProps {
  onPointerDown: (edge: "right" | "bottom" | "corner") => (e: React.PointerEvent) => void;
}

export function ResizeHandles({ onPointerDown }: ResizeHandlesProps) {
  return (
    <>
      {/* Right edge */}
      <div
        onPointerDown={onPointerDown("right")}
        className="absolute top-0 right-0 w-2 h-full cursor-ew-resize hidden md:block hover:bg-[#384872]/10 transition-colors z-10"
      />
      {/* Bottom edge */}
      <div
        onPointerDown={onPointerDown("bottom")}
        className="absolute bottom-0 left-0 h-2 w-full cursor-ns-resize hidden md:block hover:bg-[#384872]/10 transition-colors z-10"
      />
      {/* Corner */}
      <div
        onPointerDown={onPointerDown("corner")}
        className="absolute bottom-0 right-0 w-5 h-5 cursor-nwse-resize hidden md:flex items-center justify-center hover:bg-[#384872]/10 transition-colors z-20 rounded-bl-md"
      >
        <svg width="10" height="10" viewBox="0 0 10 10" className="text-slate-300">
          <path d="M9 1v8H1" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M9 5v4H5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </div>
    </>
  );
}

interface PanelDividerProps {
  onPointerDown: (e: React.PointerEvent) => void;
}

export function PanelDivider({ onPointerDown }: PanelDividerProps) {
  return (
    <div
      onPointerDown={onPointerDown}
      className="w-1 flex-shrink-0 cursor-col-resize hidden md:block hover:bg-[#384872]/20 active:bg-[#384872]/30 transition-colors"
    />
  );
}
